<template>
  <div class="roomie-radio">
    <label
      :for="id"
      class="roomie-radio__container"
      :class="{ 'roomie-radio__container--disabled': disabled }">
      <input
        :id="id"
        :data-lh-id="dataLhId"
        type="radio"
        :checked="isChecked"
        class="roomie-radio__input"
        :value="value"
        :disabled="disabled"
        @change="$emit('change', $event.target.value)">

      <RoomieCheck
        :active="isChecked"
        :disabled="disabled" />

      <span
        v-if="label"
        class="roomie-radio__label"
        :class="{ 'roomie-radio__label--disabled': disabled }">
        {{ label }}
      </span>
    </label>
  </div>
</template>

<script>
import RoomieCheck from '../RoomieCheck/index.vue'

export default {
  name: 'RoomieRadio',
  components: { RoomieCheck },
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: [Number, String],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      required: true
    },
    dataLhId: {
      type: String,
      default: ''
    }
  },
  computed: {
    isChecked() {
      return this.checked === this.value
    }
  }
}
</script>

<style
  src='./_index.scss'
  lang='scss'/>
